import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/dashboard')({
  staticData: { breadcrumb: 'Clients', breadcrumbKey: 'K_BREADCRUMB_TENANTS' },
  component: DashboardLayout,
});

function DashboardLayout() {
  return <Outlet />;
}
